import  Vue  from "vue";
import { Component, Prop } from 'vue-property-decorator'
import { Getter } from "vuex-class";

@Component({})
export default class Pagination extends Vue {
  @Prop({ default: null }) totalPages;
  @Prop({ default: null }) currentPage;
  @Prop({ default: null }) itemsPerPage;
  @Prop({ default: null }) totalObjects;

  @Getter getIsUnderMobile;

  get getArrayOfIndexes() {
    let arrayOfIndexes = [];
    if(this.totalPages > 10) {
      let i = 0;
      let numPags = 10;
      if(this.getIsUnderMobile) {
        numPags = 5;
      }
      if(this.currentPage < numPags) {
        i = 1;
      } else if(this.currentPage > this.totalPages - numPags) {
        i = this.totalPages - numPags;
      } else {
        i = this.currentPage;
      }
      for(let j = i; j <= i + numPags && j <= this.totalPages; j++) {
        arrayOfIndexes.push(j);
      }
    } else {
      for(let i = 1; i <= this.totalPages; i++) {
        arrayOfIndexes.push(i);
      }
    }
    return arrayOfIndexes;
  }

  _onClickButton(pageNumber: number) {
    this.$emit('goToPage', pageNumber)
  }


}